import axios from 'axios';
import store from '../../store/index';

export default {
	getExchanges(populate = false) {
		return axios.get(`/api/exchange/?populate=${populate}`);
	},
	getStatus() {
		return axios.get(`/api/status/`);
	},

	approve(id) {
		return axios.patch(`/api/exchange/${id}`, {});
	},
	getExchangeTime() {
		return axios.get(`/api/exchangeTime/`);
	},
	getExchangeTimeById(id) {
		return axios.get(`/api/exchangeTime/${id}`);
	},

	createExchangeTime(exchangeTime) {
		return axios.post(`/api/exchangeTime/`, exchangeTime);
	},

	updateExchangeTime(update) {
		let id = update._id;
		return axios.patch(`/api/exchangeTime/${id}`, update);
	},
	deleteExchangeTime(id) {
		return axios.delete(`/api/exchangeTime/${id}`);
	},
};
